// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sRwag{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.QDTmG{font-family:"Inter",sans-serif}
.vp2wA{font-weight:500;margin-top:8px;color:#ed4f9d;font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;-webkit-transform-origin:top;-ms-transform-origin:top;transform-origin:top}
.vp2wA .VUzG7{color:#ed4f9d;-ms-flex-negative:0;flex-shrink:0}
.VN86v{padding:0;margin-bottom:0}
.DS0DA{display:block;font-family:"Inter",sans-serif;font-size:16px;font-weight:600;color:#1e293b;margin-bottom:16px}
.FZdPm{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;margin-bottom:20px}
.soNxe{color:#64748b;font-size:14px;font-weight:400;margin-bottom:0}
.soNxe strong{color:#16a34a;font-weight:600}
.wFhyX{border:none;border-top:1px solid #e2e8f0;margin:28px 0 24px 0}
.TPNtU{margin-top:0}
.fQly3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:14px 16px;background:#fff;border:none;border-bottom:1px solid #e5e7eb;margin-bottom:0;-webkit-transition:background-color .2s;-o-transition:background-color .2s;transition:background-color .2s}
.fQly3:hover{background-color:#f9fafb}
.fQly3:last-child{border-bottom:none}
.uHOTU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:16px;-ms-flex-negative:0;flex-shrink:0}
.uHOTU svg{font-size:32px !important;color:#cbd5e1}
.e0Rmx{-webkit-box-flex:1;-ms-flex:1 1;flex:1 1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:6px;font-size:16px}
.sdMxM{font-weight:500;color:#0f172a}
.QTD2I{color:#cbd5e1;font-size:14px}
.Csz5X{color:#64748b;font-weight:400}
.QZQSF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;opacity:0;-webkit-transition:opacity .2s ease-in-out;-o-transition:opacity .2s ease-in-out;transition:opacity .2s ease-in-out}
.xy0ZD{opacity:1}
.doKDA{color:#94a3b8;background-color:rgba(0,0,0,0);border:none;border-radius:8px;padding:6px;-webkit-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease}
.doKDA:hover{background-color:#fef2f2;color:#ef4444}
.doKDA:focus{outline:none}
._WGz4{font-family:"Inter",sans-serif;font-size:13px;font-weight:500;padding:6px 12px;color:#64748b;background-color:#f8fafc;border:none;border-radius:8px;text-decoration:none;-webkit-transition:all .2s ease;-o-transition:all .2s ease;transition:all .2s ease;cursor:pointer}
._WGz4:hover{color:#3b82f6;background-color:#eff6ff;text-decoration:none}
._WGz4:focus{outline:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `sRwag`,
	"baseContainer": `QDTmG`,
	"errorMessage": `vp2wA`,
	"errorIcon": `VUzG7`,
	"addSection": `VN86v`,
	"sectionTitle": `DS0DA`,
	"domainHelperInfo": `FZdPm`,
	"domainHelperText": `soNxe`,
	"sectionDivider": `wFhyX`,
	"domainsList": `TPNtU`,
	"domainItem": `fQly3`,
	"domainIcon": `uHOTU`,
	"domainInfo": `e0Rmx`,
	"domainName": `sdMxM`,
	"domainSeparator": `QTD2I`,
	"domainEmail": `Csz5X`,
	"domainActions": `QZQSF`,
	"domainActionsVisible": `xy0ZD`,
	"deleteButton": `doKDA`,
	"setDefaultButton": `_WGz4`
};
module.exports = ___CSS_LOADER_EXPORT___;
